// Considered: none — inspector-specific composition, a numbered "reading up" list. See spec
// Reuse Audit (specs/stream-trajectory-tools.md).
//
// Source: design/metaspace-tools/metaspace-interactions.jsx:94-104.

import React from 'react';
import type { InspectorDerivationStep } from 'types/inspector';
import './DerivationStepsMolecule.scss';

export interface DerivationStepsMoleculeProps {
  /** Order is value first, then its inputs — reading up the derivation chain. Step 1 is primary. */
  steps: InspectorDerivationStep[];
  className?: string;
}

const DerivationStepsMolecule: React.FC<DerivationStepsMoleculeProps> = ({ steps, className }) => (
  <div className={['derivation-steps-molecule', className].filter(Boolean).join(' ')}>
    {steps.map((step, index) => (
      <div key={step.label} className="derivation-steps-molecule__row">
        <span
          className={
            index === 0
              ? 'derivation-steps-molecule__index derivation-steps-molecule__index--primary'
              : 'derivation-steps-molecule__index'
          }
        >
          {index + 1}
        </span>
        <span className="derivation-steps-molecule__label">{step.label}</span>
        <span className="derivation-steps-molecule__value">{step.value}</span>
      </div>
    ))}
  </div>
);

DerivationStepsMolecule.displayName = 'DerivationStepsMolecule';

export default DerivationStepsMolecule;
